/**
 *
 * @name app.module.FooterDirective
 * @copyright 2015 Empower Retirement
 * @require angular
 * @description Directive responsible for the Site Footer
 *
 */
"use strict";

import footerTemplate from "./footerTemplate";

const FooterDirective = function () {
    return {
        restrict: "E",
        controller: "FooterController",
        scope: true,
        template: footerTemplate
    };
};

export default FooterDirective;
